import { Env } from '@audius/common/services'

export const env: Env = {
  AAO_ENDPOINT: 'https://discoveryprovider.audius.co',
  AMPLITUDE_API_KEY: '86760558b8bb1b3aae61656efd4ddacb',
  AMPLITUDE_PROXY: 'https://gain2.audius.co/2/httpapi',
  API_KEY: '8acf5eb7436ea403ee536a7334faa5e9ada4b50f',
  API_URL: process.env.VITE_API_URL ?? 'https://api.audius.co',
  APP_NAME: 'audius-client',
  ARCHIVE_ENDPOINT: 'https://api.audius.co',
  AUDIUS_NETWORK_CHAIN_ID: 31524,
  AUDIUS_URL: 'https://audius.co',
  BITSKI_CALLBACK_URL: 'https://audius.co/bitski-callback.html',
  BITSKI_CLIENT_ID: '661ce11a-3e0f-4659-b365-795ad2111f42',
  CACHE_PRUNE_MIN: '250',
  CLAIM_DISTRIBUTION_CONTRACT_ADDRESS:
    '0x683c19E621A0F107a291fdAB38f80179809d61B5',
  CLAIMABLE_TOKEN_PDA: '5ZiE3vAkrdXBgyFL7KqG3RoEGBws4CjRcXVbABDLZTgx',
  CLAIMABLE_TOKEN_PROGRAM_ADDRESS:
    'Ewkv3JahEFRKkcJmpoKB7pXbnUHwjAyXiwEo4ZY2rezQ',
  COGNITO_KEY: 'live_publishable_key_9afb0a1e2e32ba707a70e66c6d309500',
  COGNITO_TEMPLATE_ID: 'flwtmp_eMMe8VQGrKvLCX',
  COINFLOW_APP_ID: '9JBW2RHC7JNJN8ZQ',
  COINFLOW_MERCHANT_ID: 'tikilabs',
  COINFLOW_PARTNER_ID: 'AUDIUS',
  ENTITY_MANAGER_ADDRESS: '0x1Cd8a543596D499B9b6E7a6eC15ECd2B7857Fd64',
  ENVIRONMENT: 'production',
  ETH_BRIDGE_ADDRESS: '0x98f3c9e6E3fAce36bAAd05FE09d375Ef1464288B',
  ETH_NETWORK_ID: '1',
  ETH_OWNER_WALLET: '0xC7310a03e930DD659E15305ed7e1F5Df0F0426C5',
  ETH_PROVIDER_URL: 'https://eth-client.audius.co',
  ETH_REGISTRY_ADDRESS: '0xd976d3b4f4e22a238c1A736b6612D22f17b6f64C',
  ETH_TOKEN_ADDRESS: '0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998',
  ETH_TOKEN_BRIDGE_ADDRESS: '0x3ee18B2214AFF97000D974cf647E7C347E8fa585',
  EXPLORE_CONTENT_URL:
    'https://download.audius.co/static-resources/explore-content.json',
  FCM_PUSH_PUBLIC_KEY:
    'BJlfnnPuZoLzcrS_K_NOJvqu_wFhguRuUDH8qPE_X-STh0CmWUuZHNPxMTr0YIHmuhKydiaSE2J0C1IAqA6YBFw',
  FINGERPRINT_ENDPOINT: 'https://fp.audius.co',
  FINGERPRINT_PUBLIC_API_KEY: 'MNtDQ4NCsNSP7YOkOiQT',
  GA_HOSTNAME: 'audius.co',
  GA_MEASUREMENT_ID: 'G-V6N1ZTVGS5',
  HCAPTCHA_BASE_URL: 'https://audius.co',
  HCAPTCHA_SITE_KEY: 'b250803e-dcba-428c-bc87-8acf559aacb9',
  IDENTITY_SERVICE: 'https://identityservice.audius.co',
  INSTAGRAM_APP_ID: '189700309435573',
  INSTAGRAM_REDIRECT_URL: 'https://audius.co/',
  LOOKUP_TABLE_ADDRESS: 'A32QiWMjwpeBpYYfr2MytJSuiTLE37VAwMWH4jG12YBd',
  OPTIMIZELY_KEY: 'DAJbGEJBC21dzFRPv8snxs',
  ORACLE_ETH_ADDRESSES: '0x9811BA3eAB1F2Cd9A2dFeDB19e8c2a69729DC8b6',
  PAYMENT_ROUTER_PROGRAM_ID: 'paytYpX3LPN98TAeen6bFFeraGSuWnomZmCXjAsoqPa',
  STAKING_BRIDGE_PROGRAM_ID: 'stkB5DZziVJT1C1VmzvDdRtdWxfs5nwcHViiaNBDK31',
  PUBLIC_HOSTNAME: 'audius.co',
  PUBLIC_PROTOCOL: 'https:',
  BASENAME: process.env.VITE_BASENAME || '',
  REACHABILITY_URL: 'https://audius.co/204',
  RECAPTCHA_SITE_KEY: '6LfVR-0ZAAAAADFcqNM1P1IafKwQwN0E_l-gxQ9q',
  REGISTRY_ADDRESS: '0xC611C82150b56E6e4Ec5973AcAbA8835Dd0d75A2',
  REOWN_PROJECT_ID: '7d4dc6821bf9e8ee5827b63ac7172bfc',
  REWARDS_MANAGER_PROGRAM_ID: 'DDZDcYdQFEMwcu2Mwo75yGFjJ1mUQyyXLWzhZLEVFcei',
  REWARDS_MANAGER_PROGRAM_PDA: '71hWFVYokLaN1PNYzTAWi13EfJ7Xt9VbSWUKsXUT8mxE',
  REWARDS_MANAGER_TOKEN_PDA: '3V9opXNpHmPPymKeq7CYD8wWMH8wzFXmqEkNdzfsZhYq',
  SAFARI_WEB_PUSH_ID: 'web.co.audius',
  SCHEME: 'audius',
  SENTRY_DSN: 'https://e26d2b01488f4b538ea235de6466c40a@s.audius.co/1457231',
  SOL_BRIDGE_ADDRESS: 'worm2ZoG2kUd4vFXhvjh93UUH596ayRfgQ2MgjNMTth',
  SOL_TOKEN_BRIDGE_ADDRESS: 'wormDTUJ6AWPNvk59vGQbDvGJmqbDTdgWgAqcLBCgUb',
  SOLANA_CLUSTER_ENDPOINT:
    'https://carolina-8qh733-fast-mainnet.helius-rpc.com',
  SOLANA_FEE_PAYER_ADDRESS: 'pqx3fvvh6b2eZBfLhTtQ5KxzU3CginmgGTmDCjk8TPP',
  SOLANA_RELAY_ENDPOINT: 'https://discoveryprovider.audius.co',
  SOLANA_TOKEN_PROGRAM_ADDRESS: 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA',
  SOLANA_WEB3_CLUSTER: 'mainnet-beta',
  STRIPE_CLIENT_PUBLISHABLE_KEY:
    'pk_live_51LPsGuCJOWtpH6AEKshlCs3L8QhAfevNvhev8K9a0u92O5ku83KRjLIqCdxgf3NhitdtmMGlw0Wjf33NjZJjZUBz006A3IoSiQ',
  SUGGESTED_FOLLOW_HANDLES:
    'https://download.audius.co/static-resources/signup-follows.json',
  TIKTOK_APP_ID: 'awa9re2w7ec3xrn6',
  USDC_MINT_ADDRESS: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
  USE_HASH_ROUTING: false,
  WAUDIO_MINT_ADDRESS: '9LzCMqDgTKYz9Drzqnpgee3SGa89up3a247ypMj2xrqM',
  WORMHOLE_ADDRESS: '0x6E7a1F7339bbB62b23D44797b63e4258d283E095',
  WORMHOLE_RPC_HOSTS:
    'https://wormhole-v2-mainnet-api.certus.one,https://wormhole.inotel.ro,https://wormhole-v2-mainnet-api.mcf.rocks,https://wormhole-v2-mainnet-api.chainlayer.network,https://wormhole-v2-mainnet-api.staking.fund,https://wormhole-v2-mainnet-api.chainlayer.network',
  EMAIL_ENCRYPTION_UUID: 61969424,
  EMAIL_ENCRYPTION_PUBLIC_KEY:
    'BMpaZ9tHeeNXvmEL1bqxbcJfi0HOcp+Zf1HARJ+N5ZPUwqYuUU67td1GgE1NjX+hb2j39OwI9wjfBmnfagHKMqk=',
  DISCORD_BOT_SERVER: 'http://discord.audius.co'
}
